import { Buffer } from 'buffer/';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'sentry';

/** whats needed for safari and ie10 */
// import 'core-js/modules/es.array.find';
// import 'core-js/modules/es.array.find-index';
// import 'core-js/modules/es.string.includes';
// import 'core-js/modules/es.array.includes';
// import 'core-js/modules/es.object.assign';
// import 'core-js/modules/es.string.starts-with';
// import 'core-js/modules/es.array.fill';
// import 'core-js/modules/es.string.repeat';
// import 'core-js/modules/es.string.code-point-at';
// import 'core-js/es/set';
// import 'core-js/es/map';
// import 'core-js/es/promise';

// Must stay above AtsApp: importing AtsApp already fires requests (redux/boot.js), and in demo
// mode they have to wait for the mocks bootDemo() installs below.
import 'demo/requestGate';
import { startDemo } from 'demo/bootState';
import { isDemo } from 'helpers/utility';
import { createRoot } from 'react-dom/client';
import AtsApp from './AtsApp';
import registerServiceWorker, { unregister } from './registerServiceWorker';

window.Buffer = Buffer;
const root = createRoot(document.getElementById('root'));

const start = async () => {
  if (isDemo()) {
    // Loads the demo on demand, so production bundles never include it.
    await startDemo();
  }
  root.render(<AtsApp />);
};

start();

if (!isDemo()) {
  registerServiceWorker();
} else {
  unregister();
}
